// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoSprite_logo__Z5Ymn","sprite":"LogoSprite_sprite__CkhKP"};